module.exports = __webpack_public_path__ + "assets/img/27_1242.43f4260b.jpg";